import { useContext } from 'react';
import { BusinessProfileContext } from '../../providers/BusinessProfileProvider';

export default function useBusinessProfile() {
  return useContext(BusinessProfileContext);
}
